import {DutchNounConjugationView} from "./DutchNounConjugationView";
import {DutchVerbConjugationView} from "./DutchVerbConjugationView";
import {ConjugationViewProps} from "../../../components/ConjugationView";
import {
    DutchAdjective,
    DutchAdjectiveResources,
    DutchNoun,
    DutchNounResources,
    DutchVerb,
    DutchVerbResources
} from "../types";
import {GeneralWordResources, PartOfSpeech} from "../../../../../common/types/words";
import {DutchAdjectiveConjugationView} from "./DutchAdjectiveConjugationView";


export function DutchConjugationView({word}: ConjugationViewProps) {

    if (word.partOfSpeech === PartOfSpeech.Noun) {
        return <DutchNounConjugationView nounMorphology={word.morphology as DutchNoun}
                                         nounResources={word.resources as GeneralWordResources<DutchNounResources> | null}/>
    }

    if (word.partOfSpeech === PartOfSpeech.Verb) {
        return <DutchVerbConjugationView verbMorphology={{...word.morphology as DutchVerb, present_plural: word.lemma}}
                                         verbResources={word.resources as GeneralWordResources<DutchVerbResources> | null}/>
    }

    if (word.partOfSpeech === PartOfSpeech.Adjective) {
        return <DutchAdjectiveConjugationView adjectiveMorphology={word.morphology as DutchAdjective}
                                              adjectiveResources={word.resources as GeneralWordResources<DutchAdjectiveResources> | null} />
    }

    return null;

}